import type { ReactNode } from 'react';
import styles from './Section.module.css';

interface SectionProps {
  title: string;
  description?: ReactNode;
  /** The content is a list of rows that brings its own padding (InfoList, ActionList). */
  flush?: boolean;
  children: ReactNode;
}

/** A titled group: a small heading above a white rounded card, like system settings screens. */
export function Section({ title, description, flush, children }: SectionProps) {
  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
        {description && <p className={styles.description}>{description}</p>}
      </header>
      <div className={flush ? `${styles.body} ${styles.flush}` : styles.body}>{children}</div>
    </section>
  );
}
